module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Burger-8b29acde76ecd359e4e0ce89a16f2c4f.svg";